import { Chip, useThemeColors, ColorsV2 } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type ZtpEnabledChipProps = {
  enablementType: 'abm' | 'preConfiguration' | 'wAutopilotEnrollment';
};

export const ZtpEnabledChip = ({ enablementType }: ZtpEnabledChipProps) => {
  const { t } = useTranslation('storefront');
  const [textColor, backgroundColor] = useThemeColors([
    ColorsV2.SUCCESS_DARK,
    ColorsV2.SUCCESS_LIGHTEST,
  ]);

  const label =
    enablementType === 'wAutopilotEnrollment'
      ? t('wautopilot.chips.enabled')
      : t(`ztp.chips.enabled.${enablementType}`);

  return (
    <Chip
      id="ztp-enabled-chip"
      icon="shield-check"
      textColor={textColor}
      backgroundColor={backgroundColor}
      variant="small">
      {label}
    </Chip>
  );
};
